// 地图配置信息

// 处理地图参数
export const formatMapParams = data => {
    const { planListData, positionList, carPositionInfo, isShowTakeOrderPoint, isShowCarIcon } = data;
    const { departureLongitude, departureLatitude, arrivalLongitude, arrivalLatitude } = planListData;
    return {
        id: planListData.id,
        drivingRoutePoint: departureLongitude && arrivalLongitude ? [departureLongitude, departureLatitude, arrivalLongitude, arrivalLatitude] : [],
        // polylinePoint: positionList.map(v => [v.longitude, v.latitude, v.displayType]),
        polylinePoint: positionList.reverse(),
        // 后端返回数据为终点-起点，进行反转处理为起点-终点
        currentPosition: carPositionInfo,
        isShowTakeOrderPoint: isShowTakeOrderPoint,
        isShowCarIcon: isShowCarIcon
    };
};

// 基本配置
export const basicConfig = {
    centerPointLongitude: '113.216596', // 中心点经度
    centerPointLatitude: '22.913121', // 中心点纬度
    mapZoom: 15 // 地图级别
};

// 起点标注配置
export const startAndEndIconConfig = {
    startIcon: require('../images/shi_ztb.png'), // 起点标注icon
    endIcon: require('../images/zhong_ztb.png'), // 终点标注icon
    takeOrderIcon: require('../images/takeOrder.png'), // 接单点标注icon
    startSendingIcon: require('../images/start.png'), // 始发地标注点icon
    endReceivingIcon: require('../images/end.png'), // 目的地标注点icon
    overLookingCarIcon: require('../images/overLookingCar.png'), // 俯视车辆地标注点
    trackMarkerIcon: require('../images/track.png') // 车辆打点标注
};

// 出行路线规划配置
export const drivingRouteConfig = {
    autoViewport: true, // 是否开启最佳视角
    strokeColor: '#78B235', // 线路颜色
    strokeWeight: 2, // 线路粗细
    strokeOpacity: 1 // 线路透明度
};

// 地图的平移缩放控件配置
export const navigationControlConfig = {
    anchor: 'BMAP_ANCHOR_BOTTOM_LEFT',
    type: 'BMAP_NAVIGATION_CONTROL_LARGE',
    enableGeolocation: false
};

// 折线配置
export const polylineConfig = {
    strokeColor: '#78B235', // 绿色
    // strokeColor: '#0094ff',// 蓝色
    strokeWeight: 6,
    strokeOpacity: 0.5,
    carIconPath: require('../images/overLookingCar.png'),
    carLabelStyle: {
        color: '#fff',
        width: '300px',
        fontSize: '12px',
        padding: '5px',
        borderColor: 'rgb(34, 41, 59)',
        borderRadius: '10px',
        backgroundColor: 'rgb(34, 41, 59)',
        transform: 'translateX(20%)',
        userSelect: 'none',
        zIndex: 80
    }
};

/**
 * @description 当前车辆标注信息
 * @param {Object} data 当前车辆定位信息
 */
export const labelContent = data => {
    return `
        <div style="display: flex;word-break: break-word;white-space: pre-line;">
        <div>当前位置:</div>
        <div>${data.address || ''}</div>
        </div>
        <div>车牌号: ${data.vehicle || ''}</div>
        <div>司机: ${data.driver || ''}</div>
        <div>联系方式:  ${data.mobilePhone || ''}</div>`;
};
/**
 * @description 当前轨迹点标注信息
 * @param {Object} data 当前轨迹定位信息
 */
export const pointContent = data => {
    return `
        <div style="text-align:left;padding-left:-20px">
        <div style="display: flex;word-break: break-word;white-space: pre-line;">
        <div>轨迹点地址:${data.address || ''}</div>
        </div>
        <div>打点时间: ${data.trackingDate || ''}</div>
        <div>当前车速: ${data.speed || ''}km/h</div>
        <div>经纬度:  ${data.longitude || ''}/${data.latitude || ''}</div>
        </div> `;
};
